import { emptyApi } from "./emptyApi";

export const UNSUPPORTED_ENTITY_TYPE = {
  S_CORP: "S_CORP",
  LLC_TAXED_AS_S_CORP: "LLC_TAXED_AS_S_CORP",
  LLC_SINGLE_MEMBER: "LLC_SINGLE_MEMBER",
} as const;

export type UnsupportedEntityType =
  (typeof UNSUPPORTED_ENTITY_TYPE)[keyof typeof UNSUPPORTED_ENTITY_TYPE];

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    notifyUnsupportedEntity: build.mutation<
      void,
      { email: string; entity_type: UnsupportedEntityType }
    >({
      query: (body) => ({
        url: "/api/inkle/platform/unsupported_entity/notify/",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useNotifyUnsupportedEntityMutation } = extendedApi;
